import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  toggleHighContrast,
  increaseFontSizePage,
  decreaseFontSizePage,
  resetFontSizePage,
} from '~/store/modules/configuration/configuration.actions';
import Icons from '../Icons/Icons.component';
import Tooltip from '../Tooltip/Tooltip.component';
import {
  MIN_ZOOM_FONTE,
  MAX_ZOOM_FONTE,
} from '~/store/modules/configuration/configuration.reducer';
import { ensureBackgroundForForeground } from '~/modules/Helper/contrast.helper';
import SmarPanelHeaderButton from '~/modules/SmarPanel/components/smarPanelHeaderButton.component';
import {
  AcessibilityBar,
  AcessibilityButton,
  AcessibilityGlyph,
} from './Acessibility.styled';

function Acessibility() {
  const dispatch = useDispatch();

  const { zoomFonte, corTema } = useSelector(state => state.configuration);
  const botaoBg = ensureBackgroundForForeground(corTema);

  const botaoAumentarDesabilitado = zoomFonte >= MAX_ZOOM_FONTE;
  const botaoDiminuirDesabilitado = zoomFonte <= MIN_ZOOM_FONTE;

  return (
    <AcessibilityBar>
      <Tooltip title="Tamanho Original" destroyTooltipOnHide>
        <AcessibilityButton
          type="button"
          $bg={botaoBg}
          tabIndex={0}
          aria-label="A - Tamanho original da fonte"
          onClick={() => dispatch(resetFontSizePage())}
        >
          <AcessibilityGlyph>A</AcessibilityGlyph>
        </AcessibilityButton>
      </Tooltip>

      <Tooltip title="Aumentar Fonte" destroyTooltipOnHide>
        <AcessibilityButton
          type="button"
          $bg={botaoBg}
          tabIndex={0}
          aria-label="A+ Aumentar fonte"
          disabled={botaoAumentarDesabilitado}
          onClick={() => dispatch(increaseFontSizePage())}
        >
          <AcessibilityGlyph>A+</AcessibilityGlyph>
        </AcessibilityButton>
      </Tooltip>

      <Tooltip title="Diminuir Fonte" destroyTooltipOnHide>
        <AcessibilityButton
          type="button"
          $bg={botaoBg}
          tabIndex={0}
          aria-label="A- Diminuir fonte"
          disabled={botaoDiminuirDesabilitado}
          onClick={() => dispatch(decreaseFontSizePage())}
        >
          <AcessibilityGlyph>A-</AcessibilityGlyph>
        </AcessibilityButton>
      </Tooltip>

      <Tooltip title="Alto Contraste">
        <AcessibilityButton
          type="button"
          $bg={botaoBg}
          tabIndex={0}
          aria-label="Alto contraste"
          onClick={() => dispatch(toggleHighContrast())}
        >
          <AcessibilityGlyph>
            <Icons.BulbOutlined />
          </AcessibilityGlyph>
        </AcessibilityButton>
      </Tooltip>
      <SmarPanelHeaderButton />
    </AcessibilityBar>
  );
}

export default Acessibility;
